import { Input } from "./ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { GAP_OPTIONS } from "../lib/pickerSheet";

const Field = ({ label, children }) => (
  <label className="flex items-center gap-2"><span className="label-mono">{label}</span>{children}</label>
);
const inputCls = "h-9 bg-[#0B0F19] border-slate-700 text-slate-100 font-mono text-xs [color-scheme:dark]";

export const SheetSettings = ({ cfg, setCfg }) => {
  const set = (k) => (v) => setCfg({ ...cfg, [k]: v });
  const setShift = (i, k, v) => setCfg({ ...cfg, shifts: cfg.shifts.map((sh, j) => (j === i ? { ...sh, [k]: v } : sh)) });
  return (
    <div className="panel px-4 py-3 flex flex-wrap items-center gap-x-6 gap-y-3" data-testid="sheet-settings">
      <div className="flex flex-wrap items-center gap-3">
        <span className="label-mono">Standard shifts</span>
        {cfg.shifts.map((sh, i) => (
          <div key={sh.name} className="flex items-center gap-1.5 rounded-md border border-slate-800 px-2 py-1" data-testid={`shift-${sh.name.toLowerCase()}`}>
            <span className="text-xs text-slate-300 w-10">{sh.name}</span>
            <Input type="time" value={sh.start} onChange={(e) => e.target.value && setShift(i, "start", e.target.value)} className={`${inputCls} w-[104px]`} data-testid={`shift-${sh.name.toLowerCase()}-start`} />
            <span className="text-slate-500">–</span>
            <Input type="time" value={sh.end} onChange={(e) => e.target.value && setShift(i, "end", e.target.value)} className={`${inputCls} w-[104px]`} data-testid={`shift-${sh.name.toLowerCase()}-end`} />
          </div>
        ))}
      </div>
      <Field label="Large gap ≥">
        <Select value={String(cfg.gapMin)} onValueChange={(v) => set("gapMin")(+v)}>
          <SelectTrigger className={`${inputCls} w-[90px]`} data-testid="gap-threshold-select"><SelectValue /></SelectTrigger>
          <SelectContent>{GAP_OPTIONS.map((g) => <SelectItem key={g} value={String(g)} className="font-mono text-xs">{g} min</SelectItem>)}</SelectContent>
        </Select>
      </Field>
      <Field label="Overtime ≥">
        <Select value={String(cfg.otMin ?? 60)} onValueChange={(v) => set("otMin")(+v)}>
          <SelectTrigger className={`${inputCls} w-[90px]`} data-testid="overtime-threshold-select"><SelectValue /></SelectTrigger>
          <SelectContent>{[30, 60, 90, 120].map((g) => <SelectItem key={g} value={String(g)} className="font-mono text-xs">{g} min</SelectItem>)}</SelectContent>
        </Select>
      </Field>
      <Field label="Lunch allowance">
        <Input type="number" min={0} max={240} value={cfg.breakMin} onChange={(e) => set("breakMin")(Math.max(0, +e.target.value || 0))} className={`${inputCls} w-[80px]`} data-testid="break-allowance-input" />
        <span className="text-xs text-slate-500">min / day</span>
      </Field>
      <p className="text-[11px] text-slate-500 lg:ml-auto max-w-sm">Each picker's shift is auto-detected from their typical hours (part-time & custom shifts included; edit on the Pickers page). Pickers without a pattern use the nearest shift below. Lost time = late start + early finish + idle gaps inside the shift, minus the lunch allowance.</p>
    </div>
  );
};
